import React from "react";
import { useTranslation } from "react-i18next";

const NoDataFound = () => {
  const { t } = useTranslation();
  return (
    <div className="table-no-data">
      <i className="ri-search-line"></i>
      <p>{t("table.noResults")}</p>
    </div>
  );
};

export default NoDataFound;
